import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {makeStyles} from '@material-ui/core/styles';

import {getPollContent, savePollAnswers} from '../../redux/polls'
import {
  Typography,
  TextField as MuiTextField,
  Button,
} from '@material-ui/core'

import DateTimePicker from '../adapters/DateTimePicker';
import DatePicker from '../adapters/DatePicker';
import TextField from '../adapters/TextField';
import Radios from '../adapters/Radios';
import Checkboxes from '../adapters/Checkboxes';

import {useParams} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import {Form} from "react-final-form";
import {FORM_ERROR} from 'final-form';

import {isValid, isDate, format, parse} from 'date-fns';
import {uk} from "date-fns/locale";
import {history} from "../../App";
import {MAIN_PAGE} from '../../constants/app-constants';
import {setSuccessInformation} from '../../redux/application';
import {isInteger, isStringValid} from '../../utils/utils';


const useStyles = makeStyles((theme) => {
    console.log(theme);
    return ({
      accordion: {
        boxShadow: theme.shadows[3]
      },
      header: {},
      subheader: {
        color: theme.palette.info.dark,
        fontStyle: 'italic'
      },
      summary: {},
      actions: {
        justifyContent: 'flex-start'
      },
      divider: {
        paddingBottom: '2px',
        marginBottom: '1em'
      },
      description: {
        whiteSpace: "break-spaces"
      },
      questionTitle: {
        whiteSpace: "break-spaces",
        fontWeight: theme.typography.fontWeightBold
      },
      rowNumber: {
        maxWidth: '3em'
      },
      /*ownAnswer: {
        marginTop: '-2.8em',
        marginLeft: '2.3em',
        paddingRight: '2.3em'
      },*/
      errorText: {
        paddingLeft: '2em',
        color: theme.palette.error.dark
      }
    })
  }
);


export default function EditPoll(props) {

  const dispatch = useDispatch();
  const classes = useStyles();


  const {pollId} = useParams();

  const [pollContent, setPollContent] = useState({});


  useEffect(async () => {
    const params = new URLSearchParams(window.location.search);
    const isForView = params.get('action') === 'view';
    const educationId = parseInt(params.get('educationId'));
    let pollContent = await dispatch(getPollContent(parseInt(pollId), educationId, isForView));
    //Варианты ответа запихиваем в более удобную форму
    pollContent?.pollQuestions?.forEach(item => {
      if ([5, 6].includes(item.questionTypeId)) {
        item.questOptions = pollContent?.pollQuestionsPreAnswers
          ?.filter(opt => opt.pollQuestionId === item.pollQuestionId)
          ?.sort((a,b) => a.pollQuestionsPreAnswerId - b.pollQuestionsPreAnswerId) //Сортировка по ИД
          ?.map(opt => ({label: opt.answerOption, value: opt.pollQuestionsPreAnswerId.toString()}))
      }
    });

    const pollAnswers =  isForView ? dbAnswersToPollAnswers(pollContent.pollAnswers, pollContent.pollQuestions) : null;

    setPollContent({
      pollTitle: pollContent.pollTitle,
      pollQuestions: pollContent.pollQuestions,
      //pollQuestionsPreAnswers: pollContent.pollQuestionsPreAnswers,
      //pollAnswers: pollContent.pollAnswers,
      pollAnswers,
      educationId,
      isForView
    });
  }, []);


  //Преобразовать ответы, полученные из базы в формат, который понимает форма
  const dbAnswersToPollAnswers = (values, pollQuestions) => {
    let result = {};
    values.forEach(item => {
      const key = `q${item.pollQuestionId}`;
      if (!result[key]) result[key] = {};
      if (item.answerContent) result[key].answerContent = item.answerContent;
      const currentQuestion = pollQuestions.find(q => q.pollQuestionId === item.pollQuestionId);

      //Заморочки с датой
      if (currentQuestion.questionTypeId === 4) {
        result[key].answerContent = parse(item.answerContent, 'dd.MM.yyyy', new Date());
      }

      //Выбор одного варианта из нескольких
      if (currentQuestion.questionTypeId === 5) {
        //Отображаем вариант "Свой вариант"
        if (!item.pollQuestionPreAnswerId && item.answerContent) result[key].pollQuestionPreAnswerId = "-1";
        //Отображаем нормальный вариант
        if (item.pollQuestionPreAnswerId) result[key].pollQuestionPreAnswerId = item.pollQuestionPreAnswerId.toString();
      }

      //Выбор многих вариантов из нескольких
      if (currentQuestion.questionTypeId === 6) {
        if (!result[key].pollQuestionPreAnswerId) result[key].pollQuestionPreAnswerId = [];
        //Заносим вариант "свой вариант"
        if (item.answerContent) result[key].pollQuestionPreAnswerId.push("-1");
        //Заносим выбранную опцию
        if (item.pollQuestionPreAnswerId) result[key].pollQuestionPreAnswerId.push(item.pollQuestionPreAnswerId.toString());
      }

    });
    return result;
  };



  //Преобразовать ответы, которые настругала форма в формат, который хочет БД
  const pollAnswersToDbFormat = (values) => {
    let res = [];
    Object.keys(values).forEach(key => {
      const pollQuestionId = parseInt(key.substr(1));
      let {answerContent, pollQuestionPreAnswerId} = values[key];
      const isMultiSelect = Array.isArray(pollQuestionPreAnswerId);
      //Если выбрана какая либо опция из предустановленных ответов и это не вариант "Свой ответ", то очищаем открытый ответ
      if (!isMultiSelect && pollQuestionPreAnswerId && pollQuestionPreAnswerId !== "-1")
        answerContent = null;
      //Если у нас массив выбранных вариантов и там нету -1 то также очищаем "свой ответ"
      if (isMultiSelect && !pollQuestionPreAnswerId.includes("-1"))
        answerContent = null;

      //Даты преобразуем к строкам
      if (isDate(answerContent))
        answerContent = format(answerContent, 'dd.MM.yyyy', {locale: uk});

      //Если у нас массив выбранных вариантов, вставляем несколько строк
      if (isMultiSelect) {
        pollQuestionPreAnswerId.forEach(ansOpt => {
          if (ansOpt !== "-1")
            res.push({pollQuestionId, pollQuestionPreAnswerId: parseInt(ansOpt)})
        })
      } else {
        //Вставка выбора из вариантов
        if (pollQuestionPreAnswerId && pollQuestionPreAnswerId !== "-1") res.push({
          pollQuestionId,
          pollQuestionPreAnswerId: parseInt(pollQuestionPreAnswerId)
        });
      }
      //Вставка открытого ответа
      if (answerContent) res.push({pollQuestionId, answerContent});
    });
    return res;
  };

  function validate(values) {
    const notFilledError = 'На дане запитання треба обов\'язково надати відповідь',
      notFilledOwnAnswerError = 'Внесть власну відповідь або оберіть одну з напередстановлених',
      dateError = 'Введено некоректне значення дати',
      integerError = 'Ви маєте ввести ціле число';

    let errors = {pollAnswers: {}};
    let failedAnswers = [];
    const {pollQuestions} = pollContent;
    pollQuestions?.forEach(item => {
      let isFailed = false;
      const key = `q${item.pollQuestionId}`,
        ans = values?.pollAnswers?.[key];
      if (item.isRequired) {
        switch (item.questionTypeId) {
          case 1: {
            if (!isStringValid(ans?.answerContent)) {
              errors.pollAnswers[key] = {answerContent: notFilledError};
              isFailed = true;
            }
            break;
          }
          case 2: {
            if (!ans?.answerContent) {
              errors.pollAnswers[key] = {answerContent: notFilledError};
              isFailed = true;
            }
            else if (!isInteger(ans?.answerContent)){
              errors.pollAnswers[key] = {answerContent: integerError};
              isFailed = true;
            }
            break;
          }
          case 3: {
            if (!ans?.answerContent) {
              errors.pollAnswers[key] = {answerContent: notFilledError};
              isFailed = true;
            }
            break;
          }
          case 4: {
            if (!ans?.answerContent) {
              errors.pollAnswers[key] = {answerContent: notFilledError};
              isFailed = true;
            } else if (!isValid(ans?.answerContent)) {
              errors.pollAnswers[key] = {answerContent: dateError};
              isFailed = true;
            }
            break;
          }
          case 5: {
            if (!ans?.pollQuestionPreAnswerId) {
              errors.pollAnswers[key] = {pollQuestionPreAnswerId: notFilledError};
              isFailed = true;
            }
            if (ans?.pollQuestionPreAnswerId === "-1" && !isStringValid(ans?.answerContent)) {
              errors.pollAnswers[key] = {answerContent: notFilledOwnAnswerError};
              isFailed = true;
            }
            break;
          }
          case 6: {
            if (!ans?.pollQuestionPreAnswerId || !ans.pollQuestionPreAnswerId.length) {
              errors.pollAnswers[key] = {pollQuestionPreAnswerId: notFilledError};
              isFailed = true;
            }
            if (ans?.pollQuestionPreAnswerId?.includes("-1") && !isStringValid(ans?.answerContent)) {
              errors.pollAnswers[key] = {answerContent: notFilledOwnAnswerError};
              isFailed = true;
            }
          }
        }
      }
      if (isFailed) failedAnswers.push(item.rn);
    });
    if (failedAnswers.length > 0)
      errors[FORM_ERROR] = `Надана некоректна відповідь на запитання: ${failedAnswers.join(', ')}`;
    return errors;

  }

  async function submitPoll(values) {
    const pollAnswers = pollAnswersToDbFormat(values.pollAnswers);
    //console.log(pollAnswers);
    await dispatch(savePollAnswers(pollId, pollContent.educationId, pollAnswers));
    history.push(MAIN_PAGE);
    await dispatch(setSuccessInformation('Дані успішно збережені'));
  }


  //TODO: вынести в адаптеры пропы DateTimePicker и др
  const title = (<>
    <Grid container>
      <Grid item xs={6}>
        <DateTimePicker
          label="Дата та час початку опитування"
          name="pollTitle.dateBegin"
          disabled={true}
          inputVariant="standard"
          InputProps={{disableUnderline: true}}
          keyboardIcon={null}
        />
      </Grid>
      <Grid item xs={6}>
        <DateTimePicker
          label="Дата та час закінчення опитування"
          name="pollTitle.dateEnd"
          disabled={true}
          inputVariant="standard"
          InputProps={{disableUnderline: true}}
          keyboardIcon={null}
        />
      </Grid>
    </Grid>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant='subtitle1' component="div" className={classes.description}>
          {pollContent?.pollTitle?.description}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {/*<TextField*/}
        {/*  multiline={true}*/}
        {/*  name="pollTitle.eduInfo"*/}
        {/*  variant="standard"*/}
        {/*  disabled={true}*/}
        {/*  InputProps={{disableUnderline: true}}*/}
        {/*  label="Навчання, до якого проводиться опитування"*/}
        {/*/>*/}
        <Typography variant='caption' color='primary'>Навчання, до якого проводиться опитування</Typography>
        <Typography variant='subtitle1'>
          {pollContent?.pollTitle?.eduInfo}
        </Typography>
      </Grid>
    </Grid>
  </>);

  const questions = values => (<>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='subtitle1'>Питання: </Typography>
        </Grid>
      </Grid>
      {
        pollContent?.pollQuestions?.map((item, index) => {
          const isTextQuestion = item.questionTypeId === 1,
            answerContentName = `pollAnswers.q${item.pollQuestionId}.answerContent`,
            answerContentOptionName = `pollAnswers.q${item.pollQuestionId}.pollQuestionPreAnswerId`,
            {isRequired} = item;

          let questOptions = [];
          if ([5, 6].includes(item.questionTypeId)) {
            questOptions = [...item.questOptions];
            if (item.isAllowOwnAnswer)
              questOptions.push({label: 'Свій варіант', value: '-1'});
          }

          return (<Grid container spacing={2} key={index}>
            <Grid item xs={1} className={classes.rowNumber}>
              <Typography variant='subtitle1' color='primary'>{item.rn}.</Typography>
            </Grid>
            <Grid item xs={11}>
              <Typography variant='subtitle1' color='primary'
                          className={classes.description}>{item.questionContent}{isRequired ?
                <span> *</span> : null}</Typography>
              {[1, 2, 3].includes(item.questionTypeId) && <TextField
                name={answerContentName}
                placeholder="Відповідь"
                multiline={isTextQuestion}
                type={isTextQuestion ? 'text' : 'number'}
                fullWidth={isTextQuestion}
                maxLength={isTextQuestion ? 4000 : 0}
                variant="standard"
                disabled={pollContent.isForView}
              />}
              {
                item.questionTypeId === 4 && <DatePicker
                  name={answerContentName}
                  placeholder="Відповідь"
                  fullWidth={false}
                  disabled={pollContent.isForView}
                />
              }
              {item.questionTypeId === 5 &&
              <>
                <Typography variant='subtitle2' color='primary'>Оберіть один із варіантів
                  відповідей {item.isAllowOwnAnswer ? 'або введіть свій варіант' : ''}: </Typography>
                <Radios
                  name={answerContentOptionName}
                  data={questOptions}
                  disabled={pollContent.isForView}
                />
              </>
              }
              {item.questionTypeId === 5 && item.isAllowOwnAnswer &&
              values.pollAnswers?.[`q${item.pollQuestionId}`]?.pollQuestionPreAnswerId === "-1" && <TextField
                name={answerContentName}
                //label="Відповідь"
                multiline={true}
                maxLength={4000}
                variant="standard"
                placeholder="Свій варіант"
                disabled={pollContent.isForView}
                //className={classes.ownAnswer}
              />
              }
              {/*{item.questionTypeId === 5 && item.isAllowOwnAnswer &&*/}
              {/*values.pollAnswers?.[`q${item.pollQuestionId}`]?.pollQuestionPreAnswerId !== "-1" && <MuiTextField*/}
              {/*  variant="standard"*/}
              {/*  fullWidth={true}*/}
              {/*  disabled={true}*/}
              {/*  placeholder="Свій варіант"*/}
              {/*  //className={classes.ownAnswer}*/}
              {/*/>*/}
              {/*}*/}
              {item.questionTypeId === 6 &&
              <>
                <Typography variant='subtitle2' color='primary'>Оберіть один або декілька із варіантів відповідей {item.isAllowOwnAnswer ? 'або введіть свій варіант' : ''}: </Typography>
                <Checkboxes
                  name={answerContentOptionName}
                  data={questOptions}
                  disabled={pollContent.isForView}
                />
              </>}

              {item.questionTypeId === 6 && item.isAllowOwnAnswer &&
              values.pollAnswers?.[`q${item.pollQuestionId}`]?.pollQuestionPreAnswerId?.includes("-1") && <TextField
                name={answerContentName}
                //label="Відповідь"
                multiline={true}
                maxLength={4000}
                variant="standard"
                placeholder="Свій варіант"
                disabled={pollContent.isForView}
                //className={classes.ownAnswer}
              />
              }
              {/*{item.questionTypeId === 6 && item.isAllowOwnAnswer &&*/}
              {/*!values.pollAnswers?.[`q${item.pollQuestionId}`]?.pollQuestionPreAnswerId?.includes("-1") && <MuiTextField*/}
              {/*  variant="standard"*/}
              {/*  fullWidth={true}*/}
              {/*  disabled={true}*/}
              {/*  placeholder="Свій варіант"*/}
              {/*  //className={classes.ownAnswer}*/}
              {/*/>*/}
              {/*}*/}
            </Grid>
          </Grid>)
        })
      }
    </>)
  ;

  //TODO: уйти от подписки на values и тогда форма должна значительно ускориться
  //https://final-form.org/docs/react-final-form/examples/subscriptions

  return (<Form
      onSubmit={submitPoll}
      validate={validate}
      subscription={{submitFailed: true, error: true, values: true}}
      initialValues={pollContent}
      render={({handleSubmit, values, error, submitFailed}) => {
        return (
          <form className={classes.form} onSubmit={handleSubmit} noValidate>
            <Typography variant='h6'>
              {pollContent?.pollTitle?.pollName}
            </Typography>
            {title}
            {questions(values)}
            <Grid container spacing={5}>
              {!pollContent.isForView &&
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="primary">Завершити</Button>
                {submitFailed && error &&
                <Typography variant="subtitle1" component="span" className={classes.errorText}>{error}</Typography>}
              </Grid>
              }
              {pollContent.isForView &&
              <Grid item xs={12}>
                <Button variant="contained" color="primary" onClick={() => history.push(MAIN_PAGE)}>Повернутись</Button>
              </Grid>
              }
            </Grid>
          </form>
        )
      }}
    />
  );
}

